import { collection } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

import { Domain } from '@superfunnel/types/domain';

import { db, functions } from '../Firebase';
import { emptyConverter } from '../utils';

export const getDomainsColRef = (accountId: string) =>
  collection(db, 'accounts', accountId, 'domains').withConverter(
    emptyConverter<Domain>(),
  );

export const addDomain = async (accountId: string, domain: string) => {
  const fn = httpsCallable(functions, 'accounts/domains/addDomain');

  const res = await fn({
    accountId,
    domain,
  });

  return res.data;
};

export const refreshDomainStatus = async (
  accountId: string,
  domainId: string,
) => {
  const fn = httpsCallable(functions, 'accounts/domains/refreshDomainStatus');

  const res = await fn({
    accountId,
    domainId,
  });

  return res.data;
};

export const deleteDomain = async (accountId: string, domainId: string) => {
  const fn = httpsCallable(functions, 'accounts/domains/deleteDomain');

  const res = await fn({
    accountId,
    domainId,
  });

  return res.data;
};

export const addReverseProxyDomain = async (
  accountId: string,
  domain: string,
) => {
  const fn = httpsCallable(functions, 'accounts/domains/addReverseProxyDomain');

  const res = await fn({
    accountId,
    domain,
  });

  return res.data;
};

export const addSubdomain = async (accountId: string, slug: string) => {
  const fn = httpsCallable(functions, 'accounts/domains/addSubdomain');

  const res = await fn({
    accountId,
    slug,
  });

  return res.data;
};
